import { getEnv } from './environment.base';

const baseUrl = 'https://api.tport.ir';

export const environment = {
  ...getEnv(baseUrl),
  production: true,
  debug: {
    login: {
      user: null,
      pass: null,
    },
  },
};
